import {
  Box,
  Typography,
  Button,
  makeStyles,
  FormControl,
  Select,
  Chip,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import Field from "./field";
import { useForm } from "react-hook-form";
import { useContext, useEffect, useState } from "react";
import TextField from "./text-field";
import { laboratoryServices } from "../services";
import { AuthContext } from "../context";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

export function FormRepresentative(props) {
  const { register, handleSubmit, errors, reset } = useForm();
  const [errorZone, setErrorZone] = useState(false);
  const [selectedZones, setSelectedZones] = useState([]);
  const [zones, setZones] = useState([]);
  const [dataZones, setDataZones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [prevdataLoading, setPrevDataLoading] = useState(false);
  const { authState } = useContext(AuthContext);
  const { labRepresentativeId } = useParams();

  const { isEdit, onHandleSubmit } = props;

  const classes = useStyles();
  async function getVisitingZones() {
    setLoading(true);
    laboratoryServices
      .getVisitingZones({
        laboratoryId: authState.user.laboratory._id,
        token: authState.token,
      })
      .then((res) => {
        if (res.status === 200) {
          setZones(
            res.response.response.filter((z) => z.status === "active") || []
          );
        }
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }
  useEffect(() => {
    getVisitingZones();
  }, []);

  useEffect(() => {
    const getLabRepresentative = async () => {
      setPrevDataLoading(true);
      laboratoryServices
        .findLabRepresentativeById({
          labRepresentativeId: labRepresentativeId,
          token: authState.token,
        })
        .then((res) => {
          if (res.status === 200) {
            const data = res.response.response || {};
            reset({
              firstName: data.firstName,
              lastName: data.lastName,
              rut: data.rut,
              email: data.email,
              phone: data.phone,
            });
            if (data.zones && data.zones.length > 0)
              setDataZones(data.zones.map((zone) => zone.visitingZoneInfo._id));
            else setDataZones([]);
          }
        })
        .catch((e) => console.error(e))
        .finally(() => setPrevDataLoading(false));
    };
    if (isEdit) getLabRepresentative();
  }, []);
  useEffect(() => {
    setSelectedZones(filterExistingIds(dataZones, zones));
  }, [zones, dataZones]);

  const onValid = (data) => {
    if (!validateSelectionZones()) return;
    onHandleSubmit({ ...data, zones: selectedZones });
  };
  const onInvalid = () => {
    if (!validateSelectionZones()) return;
  };

  const validateSelectionZones = () => {
    if (!selectedZones.length) {
      setErrorZone(true);
      return false;
    } else {
      setErrorZone(false);
      return true;
    }
  };
  return (
    <Box
      component="form"
      className={classes.form}
      onSubmit={handleSubmit(onValid, onInvalid)}
    >
      <Field
        disabled={prevdataLoading}
        label="Nombre"
        placeholder="Primer nombre..."
        id="input-firstName"
        name={`firstName`}
        inputRef={register({
          required: "Nombre requerido",
        })}
        error={errors.firstName ? true : false}
        helperText={errors.firstName ? errors.firstName.message : ""}
      />
      <Field
        disabled={prevdataLoading}
        label="Apellido"
        placeholder="Primer apellido..."
        id="input-lastName"
        name={`lastName`}
        inputRef={register({
          required: "Apellido requerido",
        })}
        error={errors.lastName ? true : false}
        helperText={errors.lastName ? errors.lastName.message : ""}
      />
      <Field
        disabled={prevdataLoading}
        label="Rut"
        placeholder="0000000-0"
        id="input-rut"
        name={`rut`}
        inputRef={register({
          required: "Rut requerido",
        })}
        error={errors.rut ? true : false}
        helperText={errors.rut ? errors.rut.message : ""}
      />
      <Field
        disabled={prevdataLoading}
        label="Correo electrónico"
        placeholder="example@mailto.com"
        id="input-email"
        name={`email`}
        autoComplete="email"
        inputRef={register({
          required: "Correo requerido",
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: "Formato de correo inválido",
          },
        })}
        error={errors.email ? true : false}
        helperText={errors.email ? errors.email.message : ""}
      />
      <Field
        disabled={prevdataLoading}
        label="Número de teléfono"
        placeholder="00000000"
        id="input-phone"
        name="phone"
        autoComplete="phone"
        inputRef={register({
          required: "Número de teléfono requerido",
          pattern: {
            value: /^\d{8,9}$/,
            message: "Debe tener 8 o 9 dígitos numéricos",
          },
        })}
        error={!!errors.phone}
        helperText={errors.phone ? errors.phone.message : ""}
      />

      <FormControl className={classes.formControl}>
        <Typography
          component="label"
          id="zones-label"
          color="textPrimary"
          style={{ fontSize: "0.875rem", marginBottom: 8 }}
        >
          Selecciona zonas de visita
        </Typography>
        <Select
          disabled={loading}
          error={errorZone}
          labelId="zones-label"
          id="demo-mutiple-chip"
          multiple
          value={selectedZones}
          onChange={(e) => setSelectedZones(e.target.value)}
          onBlur={validateSelectionZones}
          input={
            <TextField
              id="select-multiple-chip"
              placeholder="Zones"
              className={classes.input_select_zone}
            />
          }
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 48 * 4.5 + 8,
                width: 250,
              },
            },
          }}
          renderValue={(selected) => {
            return (
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                {selected.map((value) => {
                  const foundZone = zones?.find((z) => z._id === value);
                  const label = foundZone?.name || "";
                  return <Chip key={value} label={label} />;
                })}
              </div>
            );
          }}
        >
          {zones?.map((opt) => (
            <MenuItem key={opt._id} value={opt._id}>
              {opt.name}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText
          error={errorZone}
          style={{ color: errorZone ? "red" : "initial" }}
        >
          {errorZone && "Debe seleccionar al menos una zona."}
        </FormHelperText>
      </FormControl>

      <Button
        className={classes.submit_button}
        color="primary"
        variant="contained"
        type="submit"
        style={{ textTransform: "none" }}
      >
        Guardar
      </Button>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {},
  },
  input_select_zone: {
    "& .MuiInputBase-root": {
      minHeight: 43,
      height: "auto !important",
    },
  },
}));
function filterExistingIds(idsArray, objectsArray) {
  // Creamos un Set con los _id existentes en objectsArray
  const validIds = new Set(objectsArray.map((obj) => obj._id));

  // Filtramos solo los ids que están en validIds
  return idsArray.filter((id) => validIds.has(id));
}
